import React, { useState } from "react";
import { Form, Input, Button, Spin, message } from "antd";
import { KEY_RECAPTCHA, RULES_ANTD } from "../../../constants";
import ReCAPTCHA from "react-google-recaptcha";
import { useDispatch, useSelector } from "react-redux";
import { LoadingConfig } from "../../../components";
import { UserLogin } from "../../../appRedux/action/OrderAction";
import { Link, useHistory } from "react-router-dom";

const FormLogin = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [captcha, setCaptcha] = useState(false);
  let loading = useSelector((items) => items.auth.isLoading);

  // onChangeCaptcha
  const handleChangeCaptcha = () => {
    setCaptcha(!captcha);
  };
  const onFinish = async (values) => {
    const res = await dispatch(UserLogin(values));

    if (res && res.meta && res.meta.statusCode === 200) {
      message.success("Đăng nhập thành công");
      console.log(res, "login");
      loading = false;
      if (res && res.data && res.data.user.must_update_pass) {
        return history.replace("/change-password");
      } else {
        return history.replace("/manage-register");
      }
      // return history.replace("/manage-register");
    } else {
      message.error(res.meta.msg);
      // message.error("lỗi");
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className="LoginScreen">
      {loading && <LoadingConfig />}

      <Form
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        className="content"
        name="basic"
        // initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item
          label="Tài khoản"
          name="phone_number"
          rules={[RULES_ANTD.common]}
        >
          <Input placeholder="Email hoặc số điện thoại" />
        </Form.Item>
        <Form.Item label="Mật khẩu" name="password" rules={RULES_ANTD.password}>
          <Input.Password placeholder="Mật khẩu" />
        </Form.Item>

        <div className="captcha pt-3 pb-3">
          <ReCAPTCHA sitekey={KEY_RECAPTCHA} onChange={handleChangeCaptcha} />
        </div>

        <Form.Item className="boxLogin">
          <Button
            disabled={captcha ? false : true}
            type="primary"
            className="btnLogin  w-100"
            htmlType="submit"
            shape="round"
            size="large"
          >
            Đăng nhập
          </Button>
        </Form.Item>

        <Form.Item className="boxForgotPass">
          <Link to="/forgot-password">
            <Button className="btnLogin  w-100" shape="round" size="large">
              <i> Quên mật khẩu</i>
            </Button>
          </Link>
        </Form.Item>
        <Form.Item className="boxRegister">
          <Link to="/register">
            <Button className="btnLogin   w-100" shape="round" size="large">
              Đăng ký
            </Button>
          </Link>
        </Form.Item>
      </Form>
    </div>
  );
};

export default FormLogin;
